import React from "react";
import PropTypes from "prop-types";

import PromoBoxes from "./PromoBoxes";

import { PromoContainer } from "./styles";

const Promo = ({ promoContent }) => {
    return (
        <PromoContainer>
            <PromoBoxes content={promoContent} />
        </PromoContainer>
    );
};

Promo.propTypes = {
    promoContent: PropTypes.array.isRequired
};

export default Promo;
